import {Dispatch, FC, SetStateAction, useCallback, useEffect, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {personUser} from '../../../../schema/users'
import {createPerson} from '../../../../services'
import {PersonUserModel} from '../../../../model'
import {
  SelectWrapper,
  SelectAsyncWrapper,
  InputNumberWrapper,
  InputDateWrapper,
  InputTextWrapper,
} from '../../../../../../components/UI/Form/Input'
import {ShowSnackBar} from '../../../../../../util/functions'
import {SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import {useTableMaster} from '../../../../hooks'
import {ModalComponent} from '../../../../../../components/Layout/Modal'
import {initValuesPersonByUser} from '../../../../util/values/users'
import useEnterpriseService, {
  ENTERPRISE_SEARCH_MIN_LENGTH,
} from '../../../../hooks/useEnterpriseService'
import {
  isDocTypeAlphaNumeric,
} from '../../../../util/documentTypeHelpers'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getList: () => void
  detailDocument?: any
  setDetailDocument?: Dispatch<SetStateAction<any>>
}

const AddPerson: FC<Props> = ({show, setShow, getList, detailDocument, setDetailDocument}) => {
  const [maxLength, setMaxLength] = useState(0)
  const {statusUser, getStatusUserList, docType, getDocTypeList, sex, getSexList} = useTableMaster()
  const [isEnterprise, setIsEnterprise] = useState<boolean | any>(null)
  const [empresaOption, setEmpresaOption] = useState<{value: any; label: string} | null>(null)
  const {getEnterpriseSearchOptions} = useEnterpriseService()
  const methods = useForm<PersonUserModel>({
    defaultValues: initValuesPersonByUser,
    resolver: yupResolver(personUser),
    criteriaMode: 'all',
    reValidateMode: 'onChange',
    mode: 'all',
  })
  const {
    setValue,
    setError,
    reset,
    watch,
    formState: {errors},
  } = methods
  useEffect(() => {
    getDocTypeList()
    getStatusUserList()
    getSexList()
    setValue('person.tipoDocumento', detailDocument?.tipoDocumento)
    setValue('person.numeroDocumento', detailDocument?.numeroDocumento)
    setMaxLength(detailDocument?.maxLength)
  }, [])
  useEffect(() => {
    if (detailDocument) {
      setValue('person.tipoDocumento', detailDocument?.tipoDocumento)
      setValue('person.numeroDocumento', detailDocument?.numeroDocumento)
      setMaxLength(detailDocument?.maxLength)
    }
  }, [detailDocument])
  const handleClose = () => {
    setShow(false)
    reset()
    if (setDetailDocument) setDetailDocument(null)
  }

  const handleGetMaxLength = (val: any) => {
    const value = val ? val : ''
    setMaxLength(value.length)
    setValue('person.numeroDocumento', '')
    setError('person.numeroDocumento', {})
  }

  const onSubmit = async (data: PersonUserModel) => {
    try {
      console.log('[AddPerson] data.person a enviar =>', data.person)
      console.log('[AddPerson] empresaId (subcontratista) =>', data.person?.empresaId)
      const {data: res} = await createPerson({...data.person})
      if (!res.error) {
        ShowSnackBar(SUCCESS_MESSAGE_CREATE)
        handleClose()
        getList()
      } else {
        ShowSnackBar(res.message, 'error')
      }
    } catch (error) {}
  }
  let text = 'Crear Persona'

  let typeDocName = isDocTypeAlphaNumeric(watch('person.tipoDocumento'), docType)
    ? 'alphaNumeric'
    : 'numeric'

  const handleSave = methods.handleSubmit(onSubmit)
  const handleChangeSelect = (e: any) => {
    setIsEnterprise(e.target.checked)
    if (!e.target.checked) {
      setValue('person.empresaId', '')
      setEmpresaOption(null)
    }
  }

  const handleGetEmpresa = (val: any) => {
    const value = val ? val : ''
    setValue('person.empresaId', value.value)
    setEmpresaOption(val ?? null)
  }

  const loadOptionsEmpresa = useCallback(async (inputValue: string) => {
    if (!inputValue || inputValue.trim().length < ENTERPRISE_SEARCH_MIN_LENGTH) {
      return []
    }
    return getEnterpriseSearchOptions(inputValue.trim())
  }, [])

  return (
    <ModalComponent
      show={show}
      title={text}
      handleSubmit={handleSave}
      handleClose={handleClose}
      size='lg'
    >
      <FormProvider {...methods}>
        <form>
          <div className='sdx_form card'>
            <div className='row'>
              <div className='col-sm-12 col-lg-4'>
                <SelectWrapper
                  labelText='Tipo de Doc. Id.'
                  name='person.tipoDocumento'
                  data={docType}
                  onChangeValue={handleGetMaxLength}
                  required
                />
                {errors.person?.tipoDocumento && (
                  <p className='error-message form-modal'>
                    {errors.person?.tipoDocumento?.message?.toString()}
                  </p>
                )}
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputNumberWrapper
                  labelText='Número de Doc. Id.'
                  name='person.numeroDocumento'
                  textPlaceholder='Escribe el nro de documento'
                  maxLength={maxLength}
                  type={typeDocName}
                  required
                />
                {errors.person?.numeroDocumento && (
                  <p className='error-message form-modal'>
                    {errors.person?.numeroDocumento?.message?.toString()}
                  </p>
                )}
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputTextWrapper
                  labelText='Nombres'
                  name='person.nombres'
                  textPlaceholder='Escribe el nombre'
                  required
                />
                {errors.person?.nombres && (
                  <p className='error-message form-modal'>
                    {errors.person?.nombres?.message?.toString()}
                  </p>
                )}
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputTextWrapper
                  labelText='Apellido Paterno'
                  name='person.apellidoPaterno'
                  textPlaceholder='Escribe el apellido paterno'
                  required
                />
                {errors.person?.apellidoPaterno && (
                  <p className='error-message form-modal'>
                    {errors.person?.apellidoPaterno?.message?.toString()}
                  </p>
                )}
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputTextWrapper
                  labelText='Apellido Materno'
                  name='person.apellidoMaterno'
                  textPlaceholder='Escribe el apellido materno'
                  required
                />
                {errors.person?.apellidoMaterno && (
                  <p className='error-message form-modal'>
                    {errors.person?.apellidoMaterno?.message?.toString()}
                  </p>
                )}
              </div>
              <div className='col-sm-12 col-lg-4'>
                <SelectWrapper labelText='Sexo' name='person.sexoId' data={sex} required />

                {errors.person?.sexoId && (
                  <p className='error-message form-modal'>
                    {errors.person?.sexoId?.message?.toString()}
                  </p>
                )}
              </div>
            </div>
            <hr className='divider' />
            <div className='row'>
              <div className='col-sm-12 col-lg-4'>
                <InputNumberWrapper
                  labelText='Teléfono'
                  name='person.telefono'
                  textPlaceholder='Escribe el teléfono'
                  type='telephone'
                />
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputNumberWrapper
                  labelText='Teléfono 2'
                  name='person.telefono2'
                  textPlaceholder='Escribe el teléfono'
                  type='telephone'
                />
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputTextWrapper
                  labelText='Correo'
                  name='person.email'
                  textPlaceholder='Escribe el correo'
                  type='any'
                />
              </div>
              <div className='col-sm-12 col-lg-4'>
                <InputDateWrapper
                  labelText='Fecha de nacimiento'
                  name='person.fechaNacimiento'
                  minValue='1900-01-01'
                />
              </div>
              <div className='col-sm-12 col-lg-4'>
                <SelectWrapper labelText='Estado' name='person.estado' data={statusUser} required />
                {errors.person?.estado && (
                  <p className='error-message form-modal'>
                    {errors.person?.estado?.message?.toString()}
                  </p>
                )}
              </div>
            </div>
            <hr className='divider' />
            <div className='row'>
              <div className='col-sm-12 col-lg-4 d-flex align-items-center'>
                <label>¿identificación pertenece a empresa?</label>
                <div className='form-check form-check-custom form-check-solid ps-1'>
                  <input
                    className='form-check-input border border-gray-500'
                    type='checkbox'
                    data-kt-check={isEnterprise}
                    data-kt-check-target='#kt_table_users .form-check-input'
                    checked={isEnterprise}
                    onChange={handleChangeSelect}
                  />
                </div>
              </div>
              {isEnterprise && (
                <div className='col-sm-12 col-lg-4'>
                  <SelectAsyncWrapper
                    labelText='Empresa subcontratista'
                    name='person.empresaId'
                    loadOptions={loadOptionsEmpresa}
                    onChangeValue={handleGetEmpresa}
                    textPlaceholder='Escribe al menos 4 letras...'
                    value={empresaOption}
                  />
                </div>
              )}
            </div>
          </div>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {AddPerson}
